/** @format */
import angular from 'angular';
import _ from 'lodash';
import { from, isObservable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { errorServiceModule } from '../error-handler/legacy/errorService';
import { filterInput, TypeaheadComponent } from '../typeahead/typeahead.component';
import searchEmployeeTpl from './searchEmployee.tpl.html';

export const searchEmployeeModule = 'sis-components.search.searchEmployee';

(function () {
    searchEmployeeController.$inject = ['$element', '$timeout', 'personNameService'];
    angular
        .module(searchEmployeeModule, [
            'pascalprecht.translate',
            errorServiceModule,
            'sis-components.service.personNameService',
            'sis-common.l10n.localizedStringFilter',
            TypeaheadComponent.downgrade.moduleName,
        ])
        .component('searchEmployee', {
            template: searchEmployeeTpl,
            controller: searchEmployeeController,
            bindings: {
                onSelect: '&',
                disable: '=?',
                disabledPersonIds: '=?',
                employeeService: '<',
                includeStudents: '<',
                employee: '=?',
                required: '<?',
            },
        });

    function searchEmployeeController($element, $timeout, personNameService) {
        const $ctrl = this;

        $ctrl.$onInit = function () {
            if (_.isEmpty($ctrl.employeeService)) {
                throw new Error('searchEmployee directive: employeeService attribute is required');
            }
            if ($ctrl.employee && !$ctrl.employee.fullNameReversed) {
                $ctrl.employee = { ...$ctrl.employee, fullNameReversed: personNameService.getFullNameReversed($ctrl.employee) };
            }
        };

        $ctrl.selectItem = function (selectedEmployeeSearchResult) {
            const changed = $ctrl.employee !== selectedEmployeeSearchResult;
            $ctrl.employee = selectedEmployeeSearchResult;
            if (angular.isDefined($ctrl.onSelect) && changed) {
                $timeout(() => {
                    $ctrl.onSelect({ personObj: $ctrl.employee });
                });
            }
        };

        $ctrl.isDisabled = function (item) {
            if (_.includes(_.get($ctrl, 'disabledPersonIds', []), item.id)) {
                return true;
            }
            return _.get($ctrl, 'employee.id') === item.id;
        };

        $ctrl.doSearch = function (query$) {
            return query$.pipe(
                filterInput(),
                switchMap(query => {
                    const employeeSearch = $ctrl.employeeService.search(query, !!$ctrl.includeStudents);
                    return isObservable(employeeSearch) ? employeeSearch : from(employeeSearch);
                }),
                map(result =>
                    _.map(result.searchResults, resultItem => {
                        resultItem.disabled = $ctrl.isDisabled(resultItem);
                        return resultItem;
                    }),
                ),
            );
        };

        // Formats responsible person name and email for the input box AND the dropdown. Unfortunately input is either
        // a PublicPerson object (input box in some cases) or a employee search result item (dropdown / input box in some cases)
        // so we need to handle both here.
        $ctrl.getVisibleTitle = function (personOrResultItem) {
            if (!personOrResultItem) {
                return '';
            }
            const email = personOrResultItem.primaryEmail || personOrResultItem.emailAddress || '';
            return `${personNameService.getFullNameReversed(personOrResultItem)}${email.length > 0 ? ` (${email})` : ''}`;
        };
    }
})();
